import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/basketSaveForLater/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showBasketSaveForLaterSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showBasketSaveForLaterSelector };
